export default __webpack_public_path__ + "2bf82080bfa1bc42f9f122f2fc5ea162.svg";